<template>
    <div class="page">
        <div class="left_box">
            <div class="swiper">
                <el-carousel trigger="click" :height=swiperHeight>
                    <el-carousel-item v-for="(item, index) in imageData" :key="index">
                        <div class="img-item">
                            <div class="img-main">
                                <img style="width: 100%; height: 100%"
                                     v-if="item.url && isImage"
                                     :src="showLoginImg(item.url)" alt="">
                                <img style="width: 100%; height: 100%"
                                     v-else
                                     src="../assets/img/login.jpg" alt="">
                            </div>
                            <div class="top_text">
                                <div class="text-main">
                                    <div class="text-title">{{item.name}}</div>
                                    <div class="text-text" v-html="item.context"></div>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="right_box">
            <div class="top_message" v-if="showMessage">
                <span>{{errMsg}} !</span>
            </div>
            <div class="all_input_text">
                <div class="title">
                    <div class="hos_img_name">
                        <div>
                            <img v-if="hospitalMsg.url" :src="hospitalMsg.url" alt="">
                            <img v-else src="../assets/img/hos_t.png" alt="">
                        </div>
                        <div>{{hospitalMsg.name}}</div>
                    </div>
                    <div class="change_login" @click="changeLogin">
                        <span v-if="loginType">使用用户名登录</span>
                        <span v-else>使用手机号登录</span>
                    </div>
                </div>
                <div class="login">
                    <div class="login_form">
                        <div class="phonecodelogin"
                             v-if="!loginType"
                             @keydown.enter="submitForm">
                            <div class="username input_box">
                                <el-input placeholder="  请输入手机号"
                                          class="inline-input"
                                          v-model="account.phone"></el-input>
                            </div>
                            <div class="password input_box">
                                <el-input
                                        class="code_input"
                                        v-model="account.password"
                                        show-password
                                        placeholder="  请输入密码"
                                ></el-input>
                            </div>
                            <el-button class="width_400"
                                       type="primary"
                                       :disabled="btnDisable"
                                       @click="submitForm">立 即 登 录
                            </el-button>
                        </div>

                        <div class="phonecodelogin" v-else>
                            <div class="username input_box phone_box">
                                <el-input
                                        class="inline-input"
                                        v-model="account.phone"
                                        placeholder="  请输入手机号"
                                        @change="changeLoginPhone"
                                        @blur="getVerCode('1')"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        style="width: 100%;"
                                >
                                    <template slot="prepend">
                                        <i class="el-icon-phone"></i>
                                    </template>
                                </el-input>
                                <div class="err_msg" v-if="phoneErrMsg">{{phoneErrMsg}}</div>
                            </div>
                            <div class="verify_code input_box">
                                <el-input
                                        class="width_200"
                                        v-model="account.verify"
                                        placeholder="                请输入验证码"
                                        @change="changeLoginPhone"
                                        maxlength="6"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        @keyup.enter="submitForm"
                                ></el-input>
                                <el-button
                                        class="width_180_btn"
                                        :disabled="verDis"
                                        @click="getVerCode"
                                >
                                    <span v-if="verDis">{{ verTime }} 秒</span>
                                    <span v-else>获取验证码</span>
                                </el-button>
                            </div>
                            <el-button class="width_400"
                                       type="primary"
                                       :disabled="phoneLogin"
                                       @click="submitForm"
                            >立 即 登 录</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <!--
            <div class="bottom-box">
              <p v-if="title">技术支持：{{title}}</p>
              <p v-if="title2">
                完整版本：{{title2}}
                <span class="right_ver">发布版本：{{title3}}</span>
              </p>
            </div>-->
        </div>
    </div>
</template>

<script>
    import {lcSet, lcGet, lcSetWithAge, ssSet, clone} from "../global/utils";
    import config from "@/global/config"
    import {mapState} from 'vuex'

    export default {
        name: "login",
        data() {
            return {
                swiperHeight: (window.innerHeight) + 'px',
                iserror: false,
                account: {
                    phone: "",
                    password: "",
                    verify: ""
                },
                device_name: '',
                deviceData: [],
                powerList: [],
                userData: [],
                title: config.name,
                title2: config.version,
                title3: config.version_line,
                showMessage: false,
                errMsg: '',
                imageData: [
                    {
                        name: '运营管理平台',
                        context: '患者管理平台，提升患者用药服务体验。',
                        url: ''
                    }
                ],
                isImage: false,
                timer: null,
                getPower: false,

                loginType: true,
                phoneLogin: true,

                phoneErrMsg: '',
                verDis: false,
                verTime: 60,
                verValTime: null,
            }
        },
        computed: {
            ...mapState('comInformationData', {
                hospitalMsg: 'hospitalMsg'
            }),
            btnDisable() {
                return this.account.phone === '' || this.account.password === '';
            },

        },
        mounted() {
        },
        methods: {
            changeLoginPhone() {
                if (this.account.phone != "" && this.account.verify != "") {
                    if (!this.account.phone || !(/^1[3456789]\d{9}$/.test(this.account.phone))) {
                        this.phoneLogin = true
                    } else {
                        this.phoneLogin = false
                    }
                } else {
                    this.phoneLogin = true
                }
            },
            getVerCode(v) {
                this.phoneErrMsg = '';
                if (!this.account.phone) {
                    this.phoneErrMsg = '请输入手机号！';
                    return
                }
                if (!(/^1[3456789]\d{9}$/.test(this.account.phone))) {
                    this.phoneErrMsg = '请输入正确的手机号！';
                    return
                }
                if (v && v == 1) return;
                this.httpPost("/user/send_vcode", { phone: this.account.phone }).then(
                    (res) => {
                        if (res.code === 0) {
                            this.verDis = true;
                            this.verValTime = setInterval(() => {
                                this.verTime -= 1;
                                if (this.verTime === 0) {
                                    clearInterval(this.verValTime);
                                    this.verTime = 60;
                                    this.verDis = false;
                                }
                            }, 1000);
                        } else {
                            this.$notify({
                                title: "提示",
                                message: "获取验证码失败！",
                                type: "error",
                                duration: 1500,
                            });
                        }
                    }
                ).catch((err) => {
                    if (err.code === 1002) {
                        this.$notify({
                            title: "提示",
                            message: err.msg,
                            type: "error",
                            duration: 1500,
                        });
                    }
                });
            },

            changeLogin() {
                this.phoneLogin = true;
                this.loginType = !this.loginType;
            },
            showLoginImg(url) {
                if (url) {
                    let img_url = config.BASE_URL + url;
                    return img_url
                } else {
                    return '../assets/img/login.jpg'
                }

            },

            async submitForm() {
                if ((this.account.phone != "" && this.account.password != "") ||
                    (this.account.phone != "" && this.account.verify != "")) {
                    let params = {};
                    if (!this.loginType) {
                        params = {
                            phone: this.account.phone,
                            password: this.account.password,
                        };
                    } else {
                        params = {
                            phone: this.account.phone,
                            vcode: this.account.verify,
                        };
                    }
                    let url = this.loginType?'/user/phone_login':'/user/login';
                    this.httpPost(url, params).then(res => {
                        if (res.code === 0) {
                            lcSetWithAge('token', res.data.token, 1000 * 3600 * 24 * 7);
                            // lcSet("user", JSON.stringify(res.data));
                            this.$router.push("Home");
                        }
                    }).catch(err => {
                        if (err.code === 1002) {
                            this.errMsg = err.msg;
                            this.showMessage = true;
                            setTimeout(() => {
                                this.showMessage = false;
                            }, 1000 * 3)
                        }
                    })
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .page {
        background-color: #fff;
        display: flex;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        .left_box {
            flex: 1;
            .swiper {
                flex: 1;
                height: 100%;
                background: #c6e2ff;
                .img-item {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    .img-main {
                        width: 100%;
                        height: 100%;
                        img {
                            width: auto;
                            height: auto;
                            min-width: 100%;
                            min-height: 100%;
                        }
                    }
                    .top_text {
                        position: absolute;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        left: 0;
                        background: rgba(44, 44, 44, .5);
                        .text-main {
                            position: absolute;
                            top: 35%;
                            left: 15%;
                            color: #fff;
                            z-index: 999;
                            .text-title {
                                width: 400px;
                                line-height: 50px;
                                font-size: 30px;
                                border-bottom: 1px solid #fff;
                            }
                            .text-text {
                                min-width: 400px;
                                max-width: 700px;
                                line-height: 40px;
                                font-size: 20px;
                                white-space: pre-line;
                            }
                        }
                    }

                }
            }
        }
        .right_box {
            flex: 0 0 500px;
            position: relative;
            .top_message {
                height: 50px;
                line-height: 50px;
                text-align: center;
                background-color: rgba(255, 219, 220, .5);
                border-color: rgba(255, 219, 220, .3);
                color: #ff4c52;
                font-size: 15px;
            }
            .all_input_text {
                position: absolute;
                top: 40%;
                left: 0;
                right: 0;
                transform: translate(0, -50%);
                padding: 0 50px;
                .title {
                    display: flex;
                    margin-bottom: 20px;
                    justify-content: space-between;
                    .hos_img_name {
                        display: flex;
                        div {
                            line-height: 60px;
                            span {
                                font-size: 30px;
                                padding: 0 10px 0 0;
                            }
                            img {
                                /*height: 32px;*/
                                width: 32px;
                                padding: 12px 15px 0 0;
                            }
                        }
                    }
                    .change_login {
                        line-height: 60px;
                        color: #409eff;
                        cursor: pointer;
                    }
                }
                .login {
                    .login_form {
                        .phonecodelogin {
                            .input_box {
                                margin-bottom: 25px;
                                text-align: left;
                                display: flex;
                                justify-content: space-between;
                                .width_200 {
                                    width: 200px !important;
                                }
                                .width_180_btn {
                                    width: 180px;
                                }
                            }
                            .phone_box {
                                position: relative;
                                .err_msg {
                                    position: absolute;
                                    left: 50px;
                                    bottom: -18px;
                                    color: #ff4c52;
                                    font-size: 13px;
                                }
                            }
                        }
                    }
                }
            }
            .bottom-box {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                height: 100px;
                text-align: center;
                padding: 15px;
                font-size: 12px;
                /*background: #e9eaeb;*/
                p {
                    padding: 5px;
                    .right_ver {
                        margin-left: 15px;
                    }
                }
            }
        }
    }
</style>
